import styled from 'styled-components';

export const TestEmbeddedPage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
`;

export const MenuContainer = styled.div`
  display: flex;
  align-items: flex-end;
  padding: 8px;
  gap: 8px;

  .ant-row.ant-form-item {
    margin-bottom: 0;
  }

  .url-input {
    display: flex;
    align-items: flex-end;
    flex: 1;
    gap: 8px;

    .ant-row.ant-form-item {
      flex: 1;
    }
  }
`;

export const ContentContainer = styled.div`
  flex: 1;
`;

export const IframeContainer = styled.div`
  height: 100%;

  iframe {
    height: 100%;
    width: 100%;
    border: unset;
  }
`;
